import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { HttpRequestInterceptor } from '../interceptor/http-request-interceptor'
import { ValidationModule } from '../validations/validation.module'
import { PortalCommonModule } from '../common/portal-common.module'
import { DefaultFormValidationService } from '../validations/default-form-validation-service'
import { StateGateway } from './gateways/state-gateway'
import { NetworkStateGateway } from '../common/gateways/network-state-gateway'
import { EAppBeneficiaryRoutes } from './e-app-beneficiary.routes'
import { EappBeneficiaryGateway } from './gateways/EAppEnrollment-gateway'
import { NetworkEppBeneficiaryGateway } from './gateways/NetworkEappBenefitiaryGateway'
import { UserAccessGateway } from '../common/gateways/user-access-gateway'
import { NetworkUserAccessGateway } from '../common/gateways/network-user-access-gateway'
import { CurrentUserGateway } from '../common/gateways/current-user-gateway'
import { NetworkCurrentUserGateway } from '../common/gateways/network-current-user-gateway'
import { EAppVerifyComponent } from './component/e-app-verify.component'
import { FormValidationService } from '../validations/form-validation-service'
import { EAppVerifyStep2Component } from './component/e-app-verify-Step2.component'
import { BeneficiaryEnrollmentDataService } from './gateways/beneficiary-enrollment-data-service'
import { EAppEnrollmentButtonComponent } from './component/e-app-verify-correction.component'
import { EAppVerifyStep3Component } from './component/e-app-verify-Step3.component'
import { EAppEnrollmentMessagesComponent } from './component/e-app-verify-messages.component'
import { EnrollmentModule } from '../enrollment/enrollment.module'

@NgModule({
    declarations: [
        EAppVerifyComponent,
        EAppVerifyStep2Component,
        EAppVerifyStep3Component,
        EAppEnrollmentButtonComponent,
        EAppEnrollmentMessagesComponent
        // , EAppBeneficiaryComponent
    ],
    exports: [
        RouterModule
        //  EAppBeneficiaryComponent
    ],
    imports: [FormsModule, ValidationModule, CommonModule, PortalCommonModule, EnrollmentModule, RouterModule.forChild(EAppBeneficiaryRoutes)],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        { provide: StateGateway, useClass: NetworkStateGateway },
        { provide: EappBeneficiaryGateway, useClass: NetworkEppBeneficiaryGateway },
        { provide: UserAccessGateway, useClass: NetworkUserAccessGateway },
        { provide: FormValidationService, useClass: DefaultFormValidationService },
        { provide: CurrentUserGateway, useClass: NetworkCurrentUserGateway },
        { provide: BeneficiaryEnrollmentDataService, useClass: BeneficiaryEnrollmentDataService },
        //{ provide: PortalGlobals, useClass: PortalGlobals },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class EAppBeneficiaryModule {
    constructor() {
        console.log('EAppBeneficiaryModule loaded')
    }
}
